import React from "react"
import {Link as ReactRouterLink} from "react-router-dom"
import {Avatar, LinkBox, LinkOverlay} from "@chakra-ui/react"

import {GameInfo} from "@backend/types"
import {IconNameExt} from "@utils/icons"
import {CatIcon} from "@components/app"

import {GamePlayStatusBadge} from "@modules/gamePlay/components"
import {GamePlayStatus} from "@modules/gamePlay/constants"

type GameCardProps = {
    to?: string,
    info: GameInfo,
    gamePlayStatus?: GamePlayStatus
}

export function GameCard({to, info, gamePlayStatus = "notStarted"}: GameCardProps) {

    if (!info)
        return <div>error!</div>

    return <LinkBox className="rounded-xl bg-white shadow hover:shadow-lg">
        <div className="flex items-start gap-4 p-4">
            <Avatar
                bg={info.color || "rainbow"}
                icon={<CatIcon
                    icon={info.icon as IconNameExt || "blender"}
                    iconSize="lg"/>}/>
            <div>
                <h3 className="font-medium sm:text-lg">
                    {to ?
                        <LinkOverlay as={ReactRouterLink} to={to}> {info.title}</LinkOverlay> :
                        info.title
                    }
                </h3>

                <p className="text-sm text-gray-700">
                    {info.description}
                </p>
                <GamePlayStatusBadge status={gamePlayStatus}/>
            </div>
        </div>
    </LinkBox>
}